/** On or off, said in words and with a mark, never by colour alone. */
export default function RowStatus({ active }: { active: boolean }) {
  return (
    <span className={`inline-flex items-center gap-1.5 text-caption font-semibold ${active ? 'text-ink' : 'text-ink-muted'}`}>
      <span
        aria-hidden="true"
        className={`inline-block h-2 w-2 rounded-full ${active ? 'bg-navy' : 'border border-line-strong bg-transparent'}`}
      />
      {active ? 'On' : 'Off'}
    </span>
  );
}
